import React, { useCallback, useEffect, useState } from "react";
import SubscriptionService from "../../../../Service/subscription.service";
import { Button, Table, Tag } from "antd";
import { useLoader } from "../../../../Context/LoaderContext";
import { InvoiceAPIResponse } from "../../../../Interface";
import { formatPlanName } from "../../../../Utils/planUtils";
import dayjs from "dayjs";
import "./SubscriptionHistory.scss";

const SubscriptionHistory: React.FC = () => {
  const [invoices, setInvoices] = useState<InvoiceAPIResponse[]>([]);
  const { setLoading, setLoadingMessage } = useLoader();

  const fetchData = useCallback(async () => {
    const response = await SubscriptionService.getInvoices();
    setInvoices(response);
  }, []);

  useEffect(() => {
    setLoading(true);
    setLoadingMessage("Loading invoices...");
    fetchData().finally(() => {
      setLoadingMessage(null);
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData]);

  const columns = [
    {
      title: "Issued on",
      dataIndex: "invoice.date",
      key: "invoice.date",
      render: (_: any, record: InvoiceAPIResponse) =>
        dayjs(record.invoice.date).format("DD MMM YYYY"),
    },
    {
      title: "Plan",
      dataIndex: "planName",
      key: "planName",
      render: (_: any, record: InvoiceAPIResponse) =>
        formatPlanName(record.planName) + " (" + record.mode + ")",
    },
    {
      title: "Amount",
      dataIndex: "invoice.amount",
      key: "invoice.amount",
      render: (_: any, record: InvoiceAPIResponse) => {
        const currency =
          record.invoice.currency.toLowerCase() === "inr" ? "₹" : "$";
        const amount = record.invoice.amount;
        return `${currency} ${amount}`;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_: any, record: InvoiceAPIResponse) => (
        <Tag
          color={record.invoice.status === "paid" ? "green" : "red"}
          className="history__status-tag"
        >
          {record.invoice.status}
        </Tag>
      ),
    },
    {
      title: "View Invoice",
      key: "invoice.invoiceLink",
      render: (_: any, record: any) => (
        <Button
          type="link"
          href={record.invoice.invoiceLink}
          target="_blank"
          className="history__download-button"
        >
          View Invoice
        </Button>
      ),
    },
  ];

  return (
    <div className="history">
      <div
        className="table-container"
        style={{ width: "100%", overflow: "hidden", marginBottom: "20px" }}
      >
        <Table
          columns={columns}
          dataSource={invoices}
          rowKey="invoice.invoiceLink"
          pagination={false}
          size="small"
          className="history__table"
        />
      </div>
    </div>
  );
};

export default SubscriptionHistory;
